(() => {
  function normalise(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function parseItems(value) {
    return String(value || '')
      .split(/[\n;]+/)
      .map((item) => normalise(item))
      .filter(Boolean);
  }

  function getCleanLabel(link) {
    const explicitLabel = link.querySelector(
      '.menu-drawer__menu-item-text'
    );

    if (explicitLabel) {
      return normalise(explicitLabel.textContent);
    }

    const clone = link.cloneNode(true);

    clone
      .querySelectorAll(
        '.gvs-menu-badge, svg, .dropdown-arrow'
      )
      .forEach((element) => element.remove());

    return normalise(clone.textContent);
  }

  function initBadgeScript(script) {
    const header = document.getElementById('header-component');

    if (!script || !header) return;

    let config = {};

    try {
      config = JSON.parse(script.textContent || '{}');
    } catch (error) {
      return;
    }

    const rules = [
      {
        type: 'popular',
        label: config.popularLabel || 'Popular',
        items: parseItems(config.popularItems),
      },
      {
        type: 'new',
        label: config.newLabel || 'New',
        items: parseItems(config.newItems),
      },
      {
        type: 'sale',
        label: config.saleLabel || 'Sale',
        items: parseItems(config.saleItems),
      },
      {
        type: 'support',
        label: config.supportLabel || 'Help',
        items: parseItems(config.supportItems),
      },
    ].filter((rule) => rule.items.length && rule.label);

    const selectors = [
      '.menu-list__link',
      '.menu-drawer__menu-item',
      'nav[header-menu] a',
      '.mega-menu a',
      '.c-header-collection-menu a',
    ].join(',');

    function shouldSkip(link) {
      if (
        !link ||
        link.closest(
          'header-actions, .search-action, .localization-wrapper'
        )
      ) {
        return true;
      }

      if (
        !config.showOnMobile &&
        link.closest('.menu-drawer')
      ) {
        return true;
      }

      return !getCleanLabel(link);
    }

    function findRule(label) {
      return rules.find((rule) =>
        rule.items.includes(label)
      );
    }

    function applyBadges() {
      header.querySelectorAll(selectors).forEach((link) => {
        link
          .querySelectorAll('.gvs-menu-badge')
          .forEach((badge) => badge.remove());

        link.classList.remove('gvs-menu-badge-parent');

        if (shouldSkip(link)) return;

        const label = getCleanLabel(link);
        const rule = findRule(label);

        if (!rule) return;

        const badge = document.createElement('span');

        badge.className =
          `gvs-menu-badge gvs-menu-badge--${rule.type}`;

        badge.textContent = rule.label;
        badge.setAttribute('aria-hidden', 'true');

        const badgeTarget =
          link.querySelector(
            '.gvs-mobile-menu__label-line'
          ) || link;

        badgeTarget.appendChild(badge);
        link.classList.add('gvs-menu-badge-parent');
      });
    }

    applyBadges();

    // Storefront header/menu DOM is static after initial render. Only the Theme
    // Editor replaces the header section in-place, so keep the expensive subtree
    // observer out of normal customer sessions.
    if (!window.Shopify?.designMode) return;

    // Re-apply only when Horizon genuinely replaces header/menu DOM. Avoid the
    // former fixed 150/500 ms remove-and-reinsert passes, which caused needless
    // layout work and could contribute to CLS.
    window.__gvsMenuBadgesObserver?.disconnect();
    let scheduledFrame = 0;
    const observer = new MutationObserver((mutations) => {
      const hasMeaningfulChange = mutations.some((mutation) => {
        const changedNodes = [...mutation.addedNodes, ...mutation.removedNodes];
        return changedNodes.some((node) => {
          if (!(node instanceof Element)) return false;
          return !node.matches('.gvs-menu-badge') && !node.closest('.gvs-menu-badge');
        });
      });

      if (!hasMeaningfulChange || scheduledFrame) return;
      scheduledFrame = window.requestAnimationFrame(() => {
        scheduledFrame = 0;
        applyBadges();
      });
    });

    observer.observe(header, { childList: true, subtree: true });
    window.__gvsMenuBadgesObserver = observer;
  }

  function initAllBadges(root) {
    (root || document)
      .querySelectorAll(
        'script[id^="GVSMenuBadges-"]'
      )
      .forEach(initBadgeScript);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAllBadges(document)
    );
  } else {
    initAllBadges(document);
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllBadges(event.target || document);
    }
  );
})();